module.exports = __webpack_public_path__ + "img/type10040.db2988c7.png";